import { Modal, Toast } from "bootstrap";
import { getTranslation } from "../app";

$.fn.loading = function (options) {
  let defaultOptions = {
    action: "show",
    loadingText: null,
    speed: 200,
    position: "center",
    extraClasses: null,
  };

  // sourcery skip: dont-reassign-parameters
  options = $.extend(defaultOptions, options);

  let classes = [];
  if (options.position === "center") {
    classes.push("justify-content-center");
    classes.push("align-items-center");
  }

  if (options.position === "left top") {
    classes.push("justify-content-start");
    classes.push("align-items-start");
  }

  if (options.extraClasses) {
    classes.push(options.extraClasses);
  }

  // Remove previous loading
  this.children(".tta-loading").remove();

  // Create spinner
  let spinner;
  if (options.loadingText) {
    spinner = `<span class="spinner-border m-2" role="status"></span><span class="loading-text">${options.loadingText}</span>`;
  } else {
    spinner = '<span class="spinner-border m-0" role="status"></span>';
  }

  // Create loading
  let loadingHTML = [
    `<div class="tta-loading loading-two ${classes.join(
      " ",
    )}" style="display: none;">`,
    ` <div class="spinner">`,
    `  ${spinner}`,
    ` </div>`,
    `</div>`,
  ].join("");

  // Append loading
  this.append(loadingHTML);

  // Show or hide loading
  if (options.action === "hide") {
    this.children(".tta-loading").fadeOut(options.speed);
  } else {
    this.children(".tta-loading").fadeIn(options.speed);
  }
};

$.fn.modal = function (options, ...args) {
  if (options === "hideAll") {
    const openedModals = $(".modal-tta.show");
    openedModals.each((i, element) => {
      Modal.getInstance(element).hide();
    });
    // $(document).find(".modal-backdrop").remove();

    return;
  }

  if (this.length === 0) {
    return;
  }

  let modalElement = this[0];
  if (typeof this[0]._element == "object") {
    modalElement = this[0]._element;
  }

  const modal = Modal.getInstance(modalElement);
  const modalLoading = $(modalElement).find(".modalLoading");

  if (options === "content") {
    $(modalElement).find(".modal-body").html(args[0]);
    // initPlugins(modalElement);
    modalLoading.fadeOut(200);
  }

  if (options === "hide") {
    if (modal._element.classList.contains("show")) {
      modal.hide();
    } else {
      setTimeout(() => {
        modal.hide();
      }, 500);
    }
  }

  if (options === "getBsModal") {
    return modal;
  }

  if (options === "hideWithCallback") {
    $(modal).trigger("callback", args[0]);
    modal.hide();
  }
};

$.fn.serializeObject = function () {
  let self = this,
    json = {},
    push_counters = {},
    patterns = {
      validate: /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)])*$/,
      key: /[a-zA-Z0-9_]+|(?=\[])/g,
      push: /^$/,
      fixed: /^\d+$/,
      named: /^[a-zA-Z0-9_]+$/,
    };

  this.build = function (base, key, value) {
    base[key] = value;
    return base;
  };

  this.push_counter = function (key) {
    if (push_counters[key] === undefined) {
      push_counters[key] = 0;
    }
    return push_counters[key]++;
  };

  $.each($(this).serializeArray(), function () {
    // Skip invalid keys
    if (!patterns.validate.test(this.name)) {
      return;
    }

    let k,
      keys = this.name.match(patterns.key),
      merge = this.value,
      reverse_key = this.name;

    while ((k = keys.pop()) !== undefined) {
      // Adjust reverse_key
      reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), "");

      // Push
      if (k.match(patterns.push)) {
        merge = self.build([], self.push_counter(reverse_key), merge);
      }

      // Fixed
      else if (k.match(patterns.fixed)) {
        merge = self.build([], k, merge);
      }

      // Named
      else if (k.match(patterns.named)) {
        merge = self.build({}, k, merge);
      }
    }

    json = $.extend(true, json, merge);
  });

  return json;
};

export const bsModal = (type = "full", options) => {
  const defaultOptions = {
    title: "tta",
    closeOtherModals: false,
    keyboard: false,
    backdrop: "static",
    modalId: null,
  };

  // sourcery skip: dont-reassign-parameters
  options = $.extend(defaultOptions, options);
  const modalTypes = {
    full: "modal-full",
    medium: "modal-medium",
    small: "modal-small",
  };

  const modalSelector = ".modal-tta." + modalTypes[type];
  // const modalSelector = '.modal-tta';
  const copiedModalInstances = $(modalSelector + ".deep");

  // Close other modals
  if (options.closeOtherModals && copiedModalInstances.length > 0) {
    copiedModalInstances.each((i, element) => {
      copiedModalInstances[i].remove();
      Modal.getInstance(element).hide();
    });
  }

  // Check modal count
  if (copiedModalInstances.length >= 3) {
    console.log("Open modal count is limited to 3");
    return;
  }

  const baseModal = $(".modal-tta:not(.copied)");
  const newModal = baseModal.clone();

  if (options.modalId) {
    const openedModal = $(".modal-tta#" + options.modalId);
    if (openedModal.length > 0) {
      console.log("Modal with id " + options.modalId + " already opened");
      openedModal.find(".modalLoading").show();
      return Modal.getInstance(openedModal[0]);
    }
    newModal.attr("id", options.modalId);
  }

  newModal.addClass(modalTypes[type]);
  newModal.addClass("copied");
  newModal.addClass("deep");
  newModal.find(".modal-title").text(options.title);

  const modal = new Modal(newModal[0], {
    focus: false,
    backdrop: options.backdrop,
    keyboard: options.keyboard,
  });

  newModal[0].addEventListener("shown.bs.modal", () => {
    newModal[0].focus();
  });

  newModal[0].addEventListener("hide.bs.modal", () => {
    newModal.removeClass("deep");
    setModalDeepValues();
  });

  newModal[0].addEventListener("hidden.bs.modal", () => {
    newModal.remove();
  });

  $("body").append(newModal);
  setModalDeepValues();
  modal.show();

  return modal;

  //sourcery skip: avoid-function-declarations-in-blocks
  function setModalDeepValues() {
    const copiedModalInstances = $(modalSelector + ".deep");
    copiedModalInstances.each((i, element) => {
      $(element).attr("deep", copiedModalInstances.length - i);
    });

    // if ($(copiedModalInstances[copiedModalInstances.length - 1]).hasClass('modal-full')) {
    //   $('body').addClass('last-opened-modal-is-full')
    // } else {
    //   $('body').removeClass('last-opened-modal-is-full')
    // }
  }
};

export const bsToast = (options) => {
  const defaultOptions = {
    title: getTranslation("notification"),
    secondaryTitle: "",
    content: "...",
    timeout: 5000,
    autohide: true,
  };

  // sourcery skip: dont-reassign-parameters
  options = $.extend(defaultOptions, options);

  const baseToast = $(".tta-toast:not(.copied)");
  const newToast = baseToast.clone();

  newToast.addClass("copied");
  newToast.find(".toast-title").text(options.title);
  newToast.find(".toast-secondary-title").text(options.secondaryTitle);
  newToast.find(".toast-body").text(options.content);

  $(".toast-container").append(newToast);

  const toastBootstrap = Toast.getOrCreateInstance(newToast, {
    timeout: options.timeout,
    autohide: options.autohide,
  });
  toastBootstrap.show();
};
